// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-snack__content{font-size:16px;line-height:24px;letter-spacing:0}.snackbar-html ul{padding-left:0;list-style:none}.snackbar-html ul li{color:#fff!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
